(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-media-gallery"] && !Shopify.designMode) return;
  try {
    const galleries = document.querySelectorAll('.pdp-media-gallery');
  galleries.forEach((gallery) => {
    const shareButton = gallery.querySelector('[data-gallery-action="share"]');
    const zoomButton = gallery.querySelector('[data-gallery-action="zoom"]');

    if (shareButton) {
      shareButton.addEventListener('click', async () => {
        const title = document.title;
        const url = window.location.href;
        if (navigator.share) {
          try {
            await navigator.share({ title, url });
            return;
          } catch (error) {
            if (error && error.name === 'AbortError') return;
          }
        }
        if (navigator.clipboard) {
          try {
            await navigator.clipboard.writeText(url);
          } catch (error) {}
        }
      });
    }

    if (zoomButton) {
      zoomButton.addEventListener('click', () => {
        const activeSlide = gallery.querySelector('.product-media-container--zoomable[aria-hidden="false"]');
        const fallbackSlide = gallery.querySelector('.product-media-container--zoomable');
        const target = activeSlide || fallbackSlide;
        if (target) target.click();
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
